import { ModalHeader } from '@postscript/components';

import { usePaymentMethods } from 'components/billing/context/paymentMethods';
import PaymentMethodACHAccountholderForm from './PaymentMethodACHAccountholderForm';
import PaymentMethodACHMandate from './PaymentMethodACHMandate';
import PaymentMethodCardForm from './PaymentMethodCardForm';
import PaymentMethodDeleteConfirmation from './PaymentMethodDeleteConfirmation';
import { ManagePaymentMethods } from './PaymentMethods/ManagePaymentMethods';
import PaymentMethodTypeChoice from './PaymentMethodTypeChoice';

interface Props {
  close: () => void;
}

export default function PaymentMethodSteps({ close }: Props): JSX.Element {
  const { steps, step } = usePaymentMethods();

  return (
    <>
      <ModalHeader onCancel={close}>{steps?.[step]?.heading}</ModalHeader>
      {(() => {
        switch (step) {
          case 'management':
            return <ManagePaymentMethods />;
          case 'typeChoice':
            return <PaymentMethodTypeChoice />;
          case 'stripeCard':
            return <PaymentMethodCardForm />;
          case 'stripeAch':
            return <PaymentMethodACHAccountholderForm />;
          case 'stripeAchMandate':
            return <PaymentMethodACHMandate />;
          case 'deleteConfirmation':
            return <PaymentMethodDeleteConfirmation />;
          default:
            return null;
        }
      })()}
    </>
  );
}
